import { gsap } from "gsap";

function animations() {
	if( window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
		return;
	}

	let mobile      = window.matchMedia('(max-width: 768px)').matches;
	let animatables = document.querySelectorAll( '[data-animation]' );
	let observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( entry => {
			if( entry.isIntersecting ) {
				let animationString = entry.target.dataset.animation;

				animationString.split(' ').forEach( animation => {
					switch( animation ) {
						case 'slide-up-children':
							slideUpChildren( entry.target);
							break;
						case 'fade-in-children':
							fadeInChildren( entry.target );
							break;
					}
				});

				observer.unobserve( entry.target );
			}
		});
	}, {
		rootMargin: mobile ? '0px 0px -5% 0px' : '0px 0px -10% 0px',
		threshold: 1
	});

	animatables.forEach( animatable => {
		observer.observe( animatable );
	});
}

function slideUpChildren( parent ) {
	let children = parent.querySelectorAll( ':scope > *' );
	let duration = 1;
	let stagger  = .1;

	gsap.set( children, {
		translateY: 50
	});

	gsap.to( children, {
		translateY: 0,
		duration: duration,
		stagger: function(index, target, list) {
			return index * stagger;
		}
	});

	parent.style.opacity = 1;
}

function fadeInChildren( parent ) {
	let children = parent.querySelectorAll( ':scope > *' );
	let duration = 1.5;
	let stagger  = .25;
	
	gsap.set( children, {
		opacity: 0
	});

	gsap.to( children, {
		opacity: 1,
		duration: duration,
		stagger: function(index, target, list) {
			return index * stagger;
		}
	});

	parent.style.opacity = 1;
}

export { animations };